import React from 'react';
import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import getAnalyticsApiRoot from '../../utils/getAnalyticsApiRoot';
import { AnalyticsClientGuidDto } from '../../interfaces/AnalyticsClientGuidDto';
import transformAnalyticsGuid from './transformAnalyticsGuid';

export const AnalyticsGuidResourceInfo: ResourceInfo = {
  name: '/App.features.analytics.guidResource',
  url: `${getAnalyticsApiRoot()}`,
  dataDst: '/App.features.analytics.guid',
};

const AnalyticsGuidResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => (
  <Resource
    autoRequestIfEmpty
    {...AnalyticsGuidResourceInfo}
    {...props}
    transformResponse={(data: AnalyticsClientGuidDto) => transformAnalyticsGuid(data)}
  />
);
export default AnalyticsGuidResource;
